import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import TVApp from './TVApp';
import * as serviceWorker from './serviceWorker';

let params = (new URL(document.location)).searchParams;

if (params.get("tv") !== null) {

  const venue = params.get("venue")?.toLocaleLowerCase();
  
  // Load the TV display page
  ReactDOM.hydrate(
    <React.StrictMode>
      <TVApp venue={venue} />
    </React.StrictMode>,
    document.getElementById('root')
  );
} else {
   // Load the normal user-facing webpage
   ReactDOM.hydrate(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
    document.getElementById('root')
  );
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
